export const api = {
  baseUrl: window.localStorage.getItem('OVERRIDE_URL') || 'https://invest-backend.calvertimpactcapital.org/',
  baseUrlV2: window.localStorage.getItem('OVERRIDE_URL_2') || 'https://invest-backend.calvertimpactcapital.org/',
};
export const timeZone = {
  value: 'America/New_York',
};

export const logoutRedirectionURL = 'https://calvertimpact.org/investing/community-investment-note';

export const auth = {
  clientId: 'vVdng2zFtx83V9ZTLVcaGzP8BG3cq2EA',
  domain: 'invest-calvertimpactcapital.auth0.com',
  audience: 'https://invest-calvertimpactcapital.auth0.com/userinfo',
  recaptchaSitekey: '6Lcizk0UAAAAALLzBaZ-XPaKpj4WzAiqUSGyG_Gc',
  connection: 'Username-Password-Authentication',
  cognito: {
    userPoolId: 'us-east-1_DPJXnzpnZ',
    clientId: '1prk6u6ip2bf9no2s34g7rhh7g',
  },
};

export const loggly = {
  logglyKey: 'c3ca76d0-c675-4744-b3d8-8b762881b4d7',
  originSystem: 'production-frontend',
};

export const settingsApp = {
  hasBeenDisablledSignUp: 'OFF',
  showMaintenance: 'false',
};

export const env = 'production';



// WEBPACK FOOTER //
// ./src/config/config.js